export class UIGameMapViewLayers {
    constructor(){
        this.bottomLayer = 0;
        this.mapTiles = 1;
        this.ports = 2;
        this.highlightedMapTiles = 3;
        this.tileWhiteSurrounding = 4;
        this.pirate = 5;
        this.mapEdgePieces = 6;
        this.mapCityWall = 7;
        this.mapCornerPieces = 8;
        this.mapCornerKnightPieces = 9;
        this.robber = 10;
        this.metropolis = 11;
        this.chits = 12;
        this.topLayer = 13;
        this.informationPopups = 14;
    }
}
